import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { getSelectedExhibitionId } from '@app/app.reducer';
import { AppService } from '@app/app.service';
import { BaseRoute } from '@core/data-access/models/routes.model';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { HideTranslationPipe } from '@shared/pipes/hide-translation/hide-translation.pipe';
import { debounceTime, first, fromEvent, map, merge, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-reset-button',
  templateUrl: './reset-button.component.html',
  styleUrls: ['./reset-button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, HideTranslationPipe]
})
export class ResetButtonComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly store = inject(Store);
  private readonly appService = inject(AppService);

  isUserActive = signal(true);

  ngOnInit() {
    const documentClicks = fromEvent(document, 'click');
    const documentKeypress = fromEvent(document, 'keypress');

    merge(documentClicks, documentKeypress)
      .pipe(
        tap(() => {
          this.isUserActive.set(true);
        }),
        debounceTime(30000),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.isUserActive.set(false);
      });
  }

  onResetShop($event: MouseEvent | KeyboardEvent) {
    $event.preventDefault();
    $event.stopPropagation();

    this.store
      .select(getSelectedExhibitionId)
      .pipe(
        first(),
        switchMap((exhibitionId) =>
          this.appService.resetReducersWithUser(true, true, false).pipe(map(() => exhibitionId))
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((exhibitionId) => {
        // FIXME: Maybe the route should be changed with Angular router service
        window.location.replace(`/${BaseRoute.SelfRegistration}/${exhibitionId}`);
      });
  }
}
